import {getCookies} from 'rlink-utils/Cookies';
import {REGION_COOKIES} from 'rlink-regions/constants';

export default function getPreferredLanguages () {
  let languages = [];
  let cookies = getCookies();
  if (REGION_COOKIES.READING_LANGUAGE in cookies) {
    return [cookies[REGION_COOKIES.READING_LANGUAGE]];
  }

  if (typeof navigator === 'undefined') {
    // TODO: take in an arg that says how we should pre-render a particular route
    return [];
  }

  if ('languages' in navigator) {
    for (let language of navigator.languages) {
      if (!languages.includes(languages)) {
        languages.push(language);
      }
    }
  }

  if ('language' in navigator) {
    if (!languages.includes(navigator.language)) {
      languages.push(navigator.language);
    }
  }

  return languages;

}



// WEBPACK FOOTER //
// ./lib/rlink-regions/getPreferredLanguages.js